import { useLogout } from 'auth';
import { useContext, useMemo } from 'react';
import ProfileSettingsModal from '@/modules/common/components/modals/ProfileSettingsModal/index.tsx';
import { queryClient } from '@/modules/common/query.ts';
import { DropdownMenuItem, ModalProviderContext } from 'ui';
import { LogOutIcon, SettingsIcon } from 'ui/icons';

export const useSidebarProfileMenuOptions = (): DropdownMenuItem[] => {
  const { openModal } = useContext(ModalProviderContext);
  const onLogOut = useLogout({ onRemoveQueries: () => queryClient.clear() });

  return useMemo(
    () => [
      {
        label: 'Profile settings',
        icon: SettingsIcon,
        onClick: () => {
          openModal(ProfileSettingsModal);
        },
      },
      {
        label: 'Logout',
        icon: LogOutIcon,
        onClick: onLogOut,
      },
    ],
    [onLogOut, openModal],
  );
};
